// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"144":"770f7b0e","488":"68ff5e8b"}[chunkId] + ".chunk.js");